"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformUrlsWithOverrides = transformUrlsWithOverrides;
var _getRuntimeBackendUrl = require("../internals/getRuntimeBackendUrl");
var _getValueWithOverrides = require("../overrides/getValueWithOverrides");
var _types = require("../types");
function transformUrlsWithOverrides(servicesUrls) {
  return Object.keys(servicesUrls).reduce((accumulator, serviceNameKey) => {
    const serviceName = serviceNameKey;
    const newServiceName = _types.serviceMapping[serviceName];
    const serviceUrls = servicesUrls[serviceName];
    if (!serviceUrls) {
      return accumulator;
    }
    const baseUrl = (0, _getValueWithOverrides.getValueWithOverrides)(serviceName, 'base', serviceUrls.BaseUrl) ?? '';
    const internalUrl = (0, _getValueWithOverrides.getValueWithOverrides)(serviceName, 'internal', servicesUrls[serviceName]?.InternalUrl);
    const intranetUrl = (0, _getValueWithOverrides.getValueWithOverrides)(serviceName, 'intranet', servicesUrls[serviceName]?.IntranetUrl);
    const k8sUrl = (0, _getValueWithOverrides.getValueWithOverrides)(serviceName, 'k8s', servicesUrls[serviceName]?.K8sUrl);
    accumulator[newServiceName] = {
      baseUrl,
      backendUrl: (0, _getRuntimeBackendUrl.getRuntimeBackendUrl)({
        internalUrl,
        intranetUrl,
        k8sUrl,
        baseUrl
      }) ?? baseUrl,
      ...(internalUrl && {
        internalUrl
      }),
      ...(intranetUrl && {
        intranetUrl
      }),
      ...(k8sUrl && {
        k8sUrl
      })
    };
    return accumulator;
  }, {});
}
